module.exports = __webpack_public_path__ + "media/src/images/web/sujet-faq-5af1f190b80be1649ed52df90b934ca3.svg";